// To include this file in your project:
// let mui = require('mui');
// let Colors = mui.Styles.Colors;

let colors = {
  mwsGrey50:   '#eceef1',
  mwsGrey100:  '#cfd5dc',
  mwsGrey200:  '#b0bac5',
  mwsGrey300:  '#909eae',
  mwsGrey400:  '#78899c',
  mwsGrey500:  '#60748b',
  mwsGrey600:  '#54667a',
  mwsGrey700:  '#455464',
  mwsGrey800:  '#37424f',
  mwsGrey900:  '#262e38'
};

export = colors;



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/material-ui/colors.ts
 **/